<template>
  <div>
    <b-container fluid>
      <b-row class="mb-1 text-center">
        <b-col cols="6" md="6" xs="12">
          <label class="text-dark font-weight-bold">
            Orden de servicio
          </label>
          <b-form-input
            class="border-all"
            type="text"
            readOnly
            v-model="routeInfo.services[0].identifier"
          ></b-form-input>
        </b-col>
        <b-col cols="6" md="6" xs="12" >
          <label class="text-dark font-weight-bold">
            Fecha de servicio
          </label>
          <b-form-input
            class="border-all"
            readOnly
            type="text"
            v-model="routeInfo.date"
          ></b-form-input>
        </b-col>
      </b-row>
      
     <b-row class="text-center">
      <b-col cols="6" md="6" xs="12">
          <label class="text-dark font-weight-bold">
            Estado
          </label>
          <b-form-input
            class="border-all"
            readOnly
            type="text"
            v-model="routeInfo.services[0].descState"
          ></b-form-input>
        </b-col>
        <b-col cols="6" md="6" xs="12">
          <label class="text-dark font-weight-bold">
           Sub Estado
          </label>
          <b-form-input
            class="border-all"
            readOnly
            type="text"
            v-model="routeInfo.services[0].descSubState"
          ></b-form-input>
        </b-col>
     </b-row> 
     <b-row>
        <b-col cols="12" md="12" xs="12">
          <label class="text-dark font-weight-bold">
            Observaciones 
          </label>
          <b-form-textarea
                v-model="routeInfo.services[0].observationsOptional"
                readOnly
                id="textarea-large"
                size="lg"
                rows="4"
               
                class="text-medium padding-two-bottom">                   
          </b-form-textarea>
          
        </b-col>
      </b-row>
      <b-row v-if="routeInfo.photos.length">
        <b-col md="12">
          <h5>Fotos</h5>
         <Carousel :photos="routeInfo.photos"/> 
        </b-col>
      </b-row>
      <b-row v-if="signatures.length">
        <b-col md="12">
          <h5>Firmas</h5>
         <Carousel :photos="signatures"/> 
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import Carousel from './Carousel.vue'
export default {
  name: "ModalWatch",
  data() {
    return {
      optionStates: [],
      selectedState: { idTypeMotive: null, idState: null },
      optionSubstate: [],
      selectedSubState: "",
      signatures:[],
      routeInfo:{
        date:"",
        truck_identifier:"",
        services:[{
          identifier:"",
          observationsOptional:"",
          descSubState:""
        }],
        photos:[]
      }
    };
  },
  components:{Carousel},
  computed: {
    ...mapState("module", ["username"]),
  },
  props: {
    orderService: {
      type: String,
    },
    idRoute: {
      type: Number,
    },
    idService: {
      type: Number,
    },
  },
  created() {
    this.search();
  },
  methods: {
    async search() {
      try {
        
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK +
            "/route/"+
            this.idRoute
        );
        const data = response.data.signatures.map((row) => {
          return {
            id: row.id,
            idRoute: row.idRoute,
            photoUrl: row.signatureUrl,
            username: row.username,
          };
        });
        this.signatures = data;
        this.routeInfo = response.data;
      } catch (error) {
        console.log(error);
      } 
    },
    closeModalEdit() {
      this.$emit("update:modalShowEdit", false);
    },
    
  },
};
</script>

<style scoped>
.btn-white-v:hover {
  color: white !important;
  background: #626262 !important ;
}
.btn-dark {
  background-color: #405568 !important;
  border-color: #405568 !important;
  color: white;
  border-radius: 4px;
}
.btn-dark:hover {
  background-color: white !important;
  border-color: #405568 !important;
  color: #405568;
  border-radius: 4px;
}
.border-all {
  border: 1px solid #d8d8d8 !important;
}
</style>
